import Vue from 'vue'
import Vuex from 'vuex'
import storage from '@/common/storage'
const ADD_ITEMNUM = 'ADD_ITEMNUM'//添加第几题
const ADD_ITEMNUM_ITEM = 'ADD_ITEMNUM_ITEM' //跳转第N 题
const BACK_ITEMNUM = 'BACK_ITEMNUM'//返回第几题
const BACK_ITEMNUM_T = 'BACK_ITEMNUM_T'//返回第几题2

const REMBER_ANSWER = 'REMBER_ANSWER'//记录答案
const REMOVE_ANSWER = 'REMOVE_ANSWER'//移除答案
const REMOVE_ANSWER_T = 'REMOVE_ANSWER_T'//移除答案2
const REMBER_TIME = 'REMBER_TIME'//记录时间
const INITIALIZE_DATA = 'INITIALIZE_DATA'//初始化
Vue.use(Vuex)


export default new Vuex.Store({
  
  state: {
    //存放的键值对就是所要管理的状态
    postArr:[],
    level: '第一周', //活动周数
    itemNum: 1, // 第几题
    itemCheck:{//选中题的下标
      first:0,
      secend:0
    },
    answer:[
      [
            // {
            //   answer:'',
            //   flag:0,
            // }
          ],[
            // {
            //   answer:'',
            //   flag:0,
            // }
          ],[],[],[],[],[],[],[],[],[]
    ],
    tit_type:{//当前题目类型
      input : false,
      radio : false
    },
    nowTitLength:0,//当前题目总数
    now:0,//当前做到总题数的n道
    max:9,//题目总数
    allTime: 0,  //总共用时
    timer: '', //定时器
    itemDetail:[],
    // itemDetail:[[
    //   {"image":"https://hsimage.fotile.com/YJ-1.jpg",
    //   "subProblemList":[{"subProblemList":[],"problem":"烟管走吊顶","problemGrade":"2","digitLimit":null,"problemId":"6","problemType":"1","wordsNumberRange":null},
    //   {"subProblemList":[],"problem":"烟管直排","problemGrade":"2","digitLimit":null,"problemId":"7","problemType":"1","wordsNumberRange":null}],
    //   "problem":"排烟方式判断","problemGrade":"1","problemNo":"YJ-1","showPage":"1/5",
    //   "productLineName":"油烟机","subproblem":"您家的排烟方式属于以下哪种？","problemId":"1","title":"判断环境是否合适",
    //   "productLineId":"1"},
    //   {"image":"https://hsimage.fotile.com/YJ-2.jpg",
    //   "subProblemList":[{"subProblemList":[],"problem":"原烟机的烟管直径","problemGrade":"2","digitLimit":"3","problemId":"8","problemType":"2","wordsNumberRange":"150-200"}],
    //   "problem":"吊顶和吊顶空间","problemGrade":"1","problemNo":"YJ-2","showPage":"2/5",
    //   "productLineName":"油烟机","subproblem":"请根据图示测量您家原烟机的烟管直径（单：位mm/毫米）",
    //   "problemId":"2","title":"判断环境是否合适","productLineId":"1"},
    //   {"image":"https://hsimage.fotile.com/YJ-3.jpg",
    //   "subProblemList":[{"subProblemList":[],"problem":"是的，多于2处","problemGrade":"2","digitLimit":null,
    //   "problemId":"9","problemType":"1","wordsNumberRange":null},
    //   {"subProblemList":[],"problem":"不，只有2处或不满2处","problemGrade":"2","digitLimit":null,"problemId":"10","problemType":"1","wordsNumberRange":null}],
    //   "problem":"吊顶和吊顶空间","problemGrade":"1","problemNo":"YJ-3","showPage":"3/5",
    //   "productLineName":"油烟机","subproblem":"吊顶与顶棚间，距离狭窄小于140mm（14厘米）的地方，是否多于2处？","problemId":"3","title":"判断环境是否合适","productLineId":"1"},
    //   {"image":"https://hsimage.fotile.com/YJ-4.jpg","subProblemList":[{"subProblemList":[],"problem":"小于160mm（16厘米）","problemGrade":"2","digitLimit":null,
    //   "problemId":"11","problemType":"1","wordsNumberRange":null},{"subProblemList":[],"problem":"大于等于160mm,小于180mm","problemGrade":"2","digitLimit":null,
    //   "problemId":"12","problemType":"1","wordsNumberRange":null},{"subProblemList":[],"problem":"等于180mm","problemGrade":"2","digitLimit":null,"problemId":"13",
    //   "problemType":"1","wordsNumberRange":null},{"subProblemList":[],"problem":"大于180mm","problemGrade":"2","digitLimit":null,"problemId":"14",
    //   "problemType":"1","wordsNumberRange":null}],"problem":"烟管直排环境","problemGrade":"1","problemNo":"YJ-4","showPage":"4/5",
    //   "productLineName":"油烟机","subproblem":"烟管直接出墙时，孔径大小有多少？","problemId":"4","title":"判断环境是否合适","productLineId":"1"},
    //   {"image":"https://hsimage.fotile.com/YJ-5.jpg","subProblemList":[{"subProblemList":[],"problem":"未安装吊柜","problemGrade":"2","digitLimit":null,
    //   "problemId":"15","problemType":"1","wordsNumberRange":null},{"subProblemList":[{"problem":"吊柜与吊柜间的宽度（mm）","problemGrade":"3",
    //   "digitLimit":"3,4","problemId":"17","problemType":"2","wordsNumberRange":"750-1000"},{"problem":"吊柜底部与吊顶间的距离（mm）",
    //   "problemGrade":"3","digitLimit":"3,4","problemId":"18","problemType":"2","wordsNumberRange":"460-950"},
    //   {"problem":"吊柜底部到台面锅支架的距离（mm）","problemGrade":"3",
    //   "digitLimit":"3,4","problemId":"19","problemType":"2","wordsNumberRange":"650-850"},
    //   {"problem":"吊柜的深度（不含柜门）（mm）","problemGrade":"3","digitLimit":"3","problemId":"20","problemType":"2","wordsNumberRange":"317-440"}],
    //   "problem":"已安装吊柜","problemGrade":"2","digitLimit":null,"problemId":"16","problemType":"1","wordsNumberRange":null}],
    //   "problem":"测量橱柜和油烟机的关键尺寸","problemGrade":"1","problemNo":"YJ-5","showPage":"5/5","productLineName":"油烟机",
    //   "subproblem":"您家厨房是否安装吊柜？若是请测量并填写图中所示橱柜和油烟机各尺寸（单位：mm/毫米）","problemId":"5","title":"判断环境是否合适","productLineId":"1"}],
    //   [{"image":"https://hsimage.fotile.com/ZJ-1.jpg",
    //   "subProblemList":[{"subProblemList":[],"problem":"是的，能满足要求","problemGrade":"2","digitLimit":null,"problemId":"25","problemType":"1","wordsNumberRange":null},
    //   {"subProblemList":[],"problem":"不行，不能满足要求","problemGrade":"2","digitLimit":null,"problemId":"26","problemType":"1","wordsNumberRange":null}],
    //   "problem":"气源判断","problemGrade":"1","problemNo":"ZJ-1","showPage":"1/4","productLineName":"灶具",
    //   "subproblem":"您家的气源必须与所购买的产品保持一致，方太的产品支持“天然气12T”和“液化气20Y”，是否能满足您家的气源要求？",
    //   "problemId":"21","title":"判断环境是否合适","productLineId":"2"},{"image":"https://hsimage.fotile.com/ZJ-2.jpg",
    //   "subProblemList":[{"subProblemList":[],"problem":"是的，能满足要求","problemGrade":"2","digitLimit":null,"problemId":"27","problemType":"1","wordsNumberRange":null},
    //   {"subProblemList":[],"problem":"不行，不能满足要求","problemGrade":"2","digitLimit":null,"problemId":"28","problemType":"1","wordsNumberRange":null}],
    //   "problem":"通风判断","problemGrade":"1","problemNo":"ZJ-2","showPage":"2/4","productLineName":"灶具",
    //   "subproblem":"请根据图示，判断您家的安装环境是否满足方太灶具的安装要求？","problemId":"22","title":"判断环境是否合适","productLineId":"2"},
    //   {"image":"https://hsimage.fotile.com/ZJ-3.jpg",
    //   "subProblemList":[{"subProblemList":[],"problem":"是的，能满足要求","problemGrade":"2","digitLimit":null,"problemId":"29","problemType":"1","wordsNumberRange":null},
    //   {"subProblemList":[],"problem":"不行，不能满足要求","problemGrade":"2","digitLimit":null,"problemId":"30","problemType":"1","wordsNumberRange":null}],
    //   "problem":"安全判断","problemGrade":"1","problemNo":"ZJ-3","showPage":"3/4",
    //   "productLineName":"灶具","subproblem":"请根据图示，判断您家的安装环境是否满足方太灶具的安装要求？","problemId":"23","title":"判断环境是否合适","productLineId":"2"},
    //   {"image":"https://hsimage.fotile.com/ZJ-4.jpg",
    //   "subProblemList":[{"subProblemList":[],"problem":"台面的开孔长度（mm）","problemGrade":"2","digitLimit":"3,4","problemId":"31","problemType":"2",
    //   "wordsNumberRange":"600-800"},
    //   {"subProblemList":[],"problem":"台面的开孔宽度(mm)","problemGrade":"2","digitLimit":"3","problemId":"32","problemType":"2","wordsNumberRange":"300-500"},
    //   {"subProblemList":[],"problem":"台面的整体长度（mm）","problemGrade":"2","digitLimit":"3,4","problemId":"33","problemType":"2","wordsNumberRange":"≥800"},
    //   {"subProblemList":[],"problem":"台面的整体宽度（mm）","problemGrade":"2","digitLimit":"3,4","problemId":"34","problemType":"2","wordsNumberRange":"≥500"}],
    //   "problem":"测量灶具的开孔尺寸","problemGrade":"1","problemNo":"ZJ-4","showPage":"4/4",
    //   "productLineName":"灶具","subproblem":"请测量并填写图中所示各灶具开孔尺寸（单位：mm/毫米）","problemId":"24","title":"改装设计","productLineId":"2"}]
    // ],
    // itemDetail:[],
    // itemDetail: [{
    //   "topic_id": 20,
    //   "active_topic_id": 4,
    //   "type": "ONE",
    //   "topic_name": "题目一",
    //   "active_id": 1,
    //   "active_title": "欢乐星期五标题",
    //   "active_topic_phase": "第一周",
    //   "active_start_time": "1479139200",
    //   "active_end_time": "1482163200",
    //   "topic_answer": [{
    //     "topic_answer_id": 1,
    //     "topic_id": 20,
    //     "answer_name": "答案aaaa",
    //     "is_standard_answer": 0
    //   }, {
    //     "topic_answer_id": 2,
    //     "topic_id": 20,
    //     "answer_name": "正确答案",
    //     "is_standard_answer": 0
    //   }, {
    //     "topic_answer_id": 3,
    //     "topic_id": 20,
    //     "answer_name": "答案cccc",
    //     "is_standard_answer": 0
    //   }, {
    //     "topic_answer_id": 4,
    //     "topic_id": 20,
    //     "answer_name": "答案dddd",
    //     "is_standard_answer": 1
    //   }]
    // }, {
    //   "topic_id": 21,
    //   "active_topic_id": 4,
    //   "type": "MORE",
    //   "topic_name": "题目二",
    //   "active_id": 1,
    //   "active_title": "欢乐星期五标题",
    //   "active_topic_phase": "第一周",
    //   "active_start_time": "1479139200",
    //   "active_end_time": "1482163200",
    //   "topic_answer": [{
    //     "topic_answer_id": 5,
    //     "topic_id": 21,
    //     "answer_name": "答案A",
    //     "is_standard_answer": 1
    //   }, {
    //     "topic_answer_id": 6,
    //     "topic_id": 21,
    //     "answer_name": "答案B",
    //     "is_standard_answer": 0
    //   }, {
    //     "topic_answer_id": 7,
    //     "topic_id": 21,
    //     "answer_name": "正确答案",
    //     "is_standard_answer": 0
    //   }, {
    //     "topic_answer_id": 8,
    //     "topic_id": 21,
    //     "answer_name": "答案D",
    //     "is_standard_answer": 0
    //   }]
    // }, {
    //   "topic_id": 21,
    //   "active_topic_id": 4,
    //   "type": "MORE",
    //   "topic_name": "题目三",
    //   "active_id": 1,
    //   "active_title": "欢乐星期五标题",
    //   "active_topic_phase": "第一周",
    //   "active_start_time": "1479139200",
    //   "active_end_time": "1482163200",
    //   "topic_answer": [{
    //     "topic_answer_id": 9,
    //     "topic_id": 21,
    //     "answer_name": "测试A",
    //     "is_standard_answer": 1
    //   }, {
    //     "topic_answer_id": 10,
    //     "topic_id": 21,
    //     "answer_name": "BBBBBB",
    //     "is_standard_answer": 0
    //   }, {
    //     "topic_answer_id": 11,
    //     "topic_id": 21,
    //     "answer_name": "CCCCCC",
    //     "is_standard_answer": 0
    //   }, {
    //     "topic_answer_id": 12,
    //     "topic_id": 21,
    //     "answer_name": "正确答案",
    //     "is_standard_answer": 0
    //   }]
    // }, {
    //   "topic_id": 21,
    //   "active_topic_id": 4,
    //   "type": "MORE",
    //   "topic_name": "题目四",
    //   "active_id": 1,
    //   "active_title": "欢乐星期五标题",
    //   "active_topic_phase": "第一周",
    //   "active_start_time": "1479139200",
    //   "active_end_time": "1482163200",
    //   "topic_answer": [{
    //     "topic_answer_id": 13,
    //     "topic_id": 21,
    //     "answer_name": "正确答案",
    //     "is_standard_answer": 1
    //   }, {
    //     "topic_answer_id": 14,
    //     "topic_id": 21,
    //     "answer_name": "A是错的",
    //     "is_standard_answer": 0
    //   }, {
    //     "topic_answer_id": 15,
    //     "topic_id": 21,
    //     "answer_name": "D是对的",
    //     "is_standard_answer": 0
    //   }, {
    //     "topic_answer_id": 16,
    //     "topic_id": 21,
    //     "answer_name": "C说的不对",
    //     "is_standard_answer": 0
    //   }]
    // }, {
    //   "topic_id": 21,
    //   "active_topic_id": 4,
    //   "type": "MORE",
    //   "topic_name": "题目五",
    //   "active_id": 1,
    //   "active_title": "欢乐星期五标题",
    //   "active_topic_phase": "第一周",
    //   "active_start_time": "1479139200",
    //   "active_end_time": "1482163200",
    //   "topic_answer": [{
    //     "topic_answer_id": 17,
    //     "topic_id": 21,
    //     "answer_name": "错误答案",
    //     "is_standard_answer": 1
    //   }, {
    //     "topic_answer_id": 18,
    //     "topic_id": 21,
    //     "answer_name": "正确答案",
    //     "is_standard_answer": 0
    //   }, {
    //     "topic_answer_id": 19,
    //     "topic_id": 21,
    //     "answer_name": "错误答案",
    //     "is_standard_answer": 0
    //   }, {
    //     "topic_answer_id": 20,
    //     "topic_id": 21,
    //     "answer_name": "错误答案",
    //     "is_standard_answer": 0
    //   }]
    // }],
    answerid: [], //答案id
  },
  mutations: {
    updateItemDetail (state,value){
      state.itemDetail = value
    },
    //点击进入下一题
    [ADD_ITEMNUM](state, num) {
      console.log('进入下一题前',state.itemCheck)
      // state.itemNum += num;
      state.itemCheck.secend += num;
    },
    [ADD_ITEMNUM_ITEM](state,num){
      console.log('进入下n题前',num)
      // state.itemNum += num;
      state.itemCheck.secend = num;
      console.log('进入下n题后',state.itemCheck)
    },
    //点击进入上一题
    [BACK_ITEMNUM](state, num) {
      state.itemNum -= num;
    },
    
    //点击进入上一题2
    [BACK_ITEMNUM_T](state, itmes) {
      console.log('点击进入上一题2前',itmes,)
      console.log('adsdf',state.itemDetail[itmes.first][itmes.secend])
      console.log('adsdf222',state.postArr)
      //点击返回（n）,清空（n+1）的postarr(选择题的值)，itemDetail（填空题的值）

      //找到对应的postarr 选择题id 移除
      let nitem = state.itemDetail[itmes.first][itmes.secend].subProblemList;//二级nodes
      if(nitem.length > 0){
       
        nitem.forEach((item1,index1) => {//(总题的值)
          // console.log('遍历nitem中',item1)
          // 判断总题中的填空题答案中是否存在当前题的答案value,有则移除
            if(item1.subProblemList.length > 0){
              item1.subProblemList.forEach((item3,index3)=>{
                console.log('遍历三级nodes-item中',item3)
                if(item3.value || item3.value == '0'){
                  // 找到相同id，移除
                  // item1.subProblemList.splice(index3,1)
                  item3.value = '';
                  item3.flag = 0;
                  // delete  item3.value
                  // console.log('移除后',item1.subProblemList)
                }
              })
            }
          // 判断选择题答案中是否存在当前题的答案，有则移除
          state.postArr.forEach((item2,index2)=>{//(选择题的值)
            // console.log('遍历postArr中',item2.problemId)
            if(item1.problemId  == item2.problemId){
              // console.log('找到了相同的',item1.problemId,item2.problemId,index2)
              // 找到相同id，移除
              state.postArr.splice(index2,1)
              // console.log('移除后的',state.postArr)
            }
          })
          
        });
        
      }
     
      // state.itemCheck.first == itemCheck.first;
      // 判断是否是第一个系列，是则first不再--
      // if(itmes.first == 0){
      //   if(itmes.secend != 0){
      //     state.itemCheck.secend -= 1; // secend--
      //   }
      // }else{
      //   state.itemCheck.first -= 1;
      //   if(itmes.secend != 0){
      //     state.itemCheck.secend -= 1; // secend--
      //   }else{
      //     state.itemCheck.secend = state.answer[state.itemCheck.first].length;
      //     console.log('adad',state.itemCheck.first, state.itemCheck.secend)
      //   }
      // }
      let ndata = state.itemDetail[itmes.first][itmes.secend-1];//当前的数据
      // 判断是油烟机，是否是[0][3],是则返回到[0][0]，即1-4 === 4-1
      if(ndata && ndata.productLineId && ndata.productLineId == '1'  && itmes.first == 0 && itmes.secend == 3 && storage.session_get('return') && storage.session_get('return').to == 3){
        state.itemCheck.first =0; 
        state.itemCheck.secend =0; 
        return
      }
      //  storage.session_set(`return3`,obj)
      // 判断油烟机，是否是[0][4],是则返回到[0][2]，即3-5 === 5-3，是3-5并且
      if( ndata && ndata.productLineId && ndata.productLineId == '1' && itmes.first == 0 && itmes.secend == 4 && storage.session_get('return') && storage.session_get('return').to == 4){
        state.itemCheck.first =0; 
        state.itemCheck.secend =2; 
        return
      }

      if(itmes.first != 0 && itmes.secend != 0){//n,n
        state.itemCheck.secend =itmes.secend - 1; // secend--
      }else if(itmes.first != 0 && itmes.secend == 0){//n,0  1 0
        state.itemCheck.first = itmes.first - 1;// first--
        state.itemCheck.secend = state.answer[itmes.first].length-1;//secend = n系列的secend长度
      }else if(itmes.first == 0 && itmes.secend != 0){//0,0
        // state.itemCheck.first -= 1;// first--
        state.itemCheck.secend == itmes.secend--;//secend = n系列的secend长度
      }
      // state.itemNum -= num;
    },
    //记录答案
    [REMBER_ANSWER](state, id) {
      state.answerid.push(id);
    },
    //移除答案
    [REMOVE_ANSWER](state, id) {
      console.log('移除答案前',state.answerid)
      // state.answerid.push(id);
      state.answerid.splice(state.answerid.findIndex(item => item === id), 1)
      console.log('移除答案后',state.answerid)
    },
    //移除答案2
    [REMOVE_ANSWER_T](state, id) {
      console.log('移除答案2前',state.answer)
      // state.answerid.push(id);
      state.answerid.splice(state.answerid.findIndex(item => item === id), 1)
      console.log('移除答案2后',state.answerid)
    },
    //记录做题时间
    [REMBER_TIME](state) {
      state.timer = setInterval(() => {
        state.allTime++;
      }, 1000)
    },
    // 初始化信息，
    [INITIALIZE_DATA](state) {
      state.itemNum = 1;
      state.allTime = 0;
      state.answerid = [];
    },
    changeRadio(state){
      console.log('改变radio前',state.tit_type.radio)
      state.tit_type.radio = true;
      console.log('改变radio后',state.tit_type)
    },
    changeInput(state){
      console.log('改变Input前',state.tit_type.input)
      state.tit_type.input = true;
      console.log('改变Input前',state.tit_type.input)
    },
    cinitTitType(state){
      // console.log('cinitTitType前',state.itemCheck.first,state.itemCheck.secend)
      let items = state.itemDetail[state.itemCheck.first][state.itemCheck.secend].subProblemList;
      // console.log('itemsitems',state.itemDetail[state.itemCheck.first][1].subProblemList)
      // let inputsArr = [];
      // let radiosArr = [];
      let inputs = 0;
      let radios = 0;
      let length = 0;
      items.forEach((item,index)=>{
        if(item.problemType == '1'){//radio
          radios++;
        }else{
          inputs++;
        }
        length++;
        if(item.subProblemList){
          item.subProblemList.forEach((item1,index1)=>{
            if(item1.problemType == '1'){//radio
              radios++;
            }else{
              inputs++;
            }
            length++;
          })
        }
        // if(item.problemType == '1'){//radio
        //   radios++;
        // }else{
        //   inputs++;
        // }
      })
      
      console.log('初始了a2222',inputs,radios,items.length)

      if(inputs == length){//全是inputs,则把radio = true,input = false
        state.tit_type.radio = true;
        state.tit_type.input = false;
      }else if(radios == length){//全是radios,则把input = true,radio = false
        state.tit_type.input = true;
        state.tit_type.radio = false;
      }else{
        state.tit_type.input = false;
        state.tit_type.radio = false;
      }
    },
    cinitTitType2(state,form,sub){
      let length = 0;
      // console.log('cinitTitType前',state.itemCheck.first,state.itemCheck.secend)
     
        let items = state.itemDetail[state.itemCheck.first][state.itemCheck.secend].subProblemList;
        console.log('itemsitems2222',items,form,sub)
        // state.nowTitLength ++;
        length++;
        if(form == '2' && sub == '1'){
          // state.itemCheck.three
          items.forEach((item,index)=>{
            console.log('当天',state.itemCheck.first,state.itemCheck.secend)
            if(item.subProblemList.length > 0){
              console.log('hhhhh222',item.subProblemList.length)
              length += item.subProblemList.length;
              console.log('长度222',length)
            }
          })
        }
      console.log('type2222',items.length,length)

    },
    cnext(state,num){
      //进入下一系列,first+=1,secen=d0
      console.log('进入下一系列前',state.itemCheck)
      state.itemCheck.first += 1;
      state.itemCheck.secend = 0;
      console.log('进入下一系列后',state.itemCheck)
    },
    // 初始化信息2
    initData(state){
      state.itemCheck.first = 0;
      state.itemCheck.secend = 0;
      console.log('初始化后',state)
    },
    //移除post_Arr
    remove_postArr(state){
      state.postArr = [];
      console.log('移除post_Arr后',state.postArr)

    },
    // 改变itemDetail值
    change_itemDetail(state,data){
      console.log('改变itemDetail值前',state,data)
      state.itemDetail = data;
      console.log('改变itemDetail值r后',state.itemDetail)
    },
    // 改变postArr值
    change_postArr(state,data){
      console.log('改变postArr值前',state,data)
      state.postArr = data;
      console.log('改变postArr值r后',state.postArr)
    }
  },
  actions: {
    addNum({ commit, state },type = 1) {
      console.log('添加n题',type)
      
      //点击下一题，记录答案id，判断是否是最后一题，如果不是则跳转下一题
      // commit('REMBER_ANSWER', id);
      // if (state.itemNum < state.itemDetail.length) {
      if (state.itemCheck.secend < state.max) {
        
        if(type == 2){//type = 2，跳转1-4，type =3 跳转3-5
          commit('ADD_ITEMNUM_ITEM', 3);
          return
        }
        if(type == 3){
          commit('ADD_ITEMNUM_ITEM', 4);
          return
        }else{
          commit('ADD_ITEMNUM', 1);
          return
        }
      }
    },
    backNum({ commit, state }, id) {
      console.log('回退n题')
      //点击返回，删除记录答案id
      commit('REMOVE_ANSWER', id);
      
      commit('BACK_ITEMNUM', 1);
      // if (state.itemNum < state.itemDetail.length) {
      //   commit('ADD_ITEMNUM', 1);
      // }
    },
    backNum2({ commit }, itmes) {
      console.log('回退2n题',itmes,itmes.first,itmes.secend)
      //点击返回，删除记录答案id
      // commit('REMOVE_ANSWER2', id);
      // 返回上一题
      commit('BACK_ITEMNUM_T', itmes);
      // if (state.itemNum < state.itemDetail.length) {
      //   commit('ADD_ITEMNUM', 1);
      // }
    },
    next({ commit }){
      commit('cnext', 1);
    },
    //初始化信息
    initializeData({ commit }) {
      commit('INITIALIZE_DATA');
    },
    //初始化信息2
    initializeData2({ commit }) {
      commit('initData');
    },
    achangeRadio({ commit, state }){
      console.log('改变radio',)
      commit('changeRadio');
    },
    achangeInput({ commit, state }){
      console.log('改变input',)
      commit('changeInput');
    },
    initTitType({ commit, state },form,sub){
      // console.log('初始了a',state.itemCheck)
      // commit('cinitTitType')
      console.log('打印',form,sub)
      commit('cinitTitType2',form,sub)
    },
    updateItemDetail({commit},val){
      commit('updateItemDetail');
    },
    //移除post_Arr
    removePostArr({commit}){
      commit('remove_postArr');
    },
    // 改变值
    changeValue({commit},data){
      commit('change_itemDetail',data);
    },
    // 改变值2
    changeValue2({commit},data){
      commit('change_postArr',data);
    },
  },
  modules: {
    
  }
})
